import React, { useState } from "react";
import ToastPopup from "./ToastPopup";
import { EditQuestionModalProps, createToastMessage, ToastMessage } from '../interFaces/interfaces';
import "../css/others/Popup.css";
const AdminCheckListDetailsEdit: React.FC<EditQuestionModalProps> = ({ question, onClose, onSave, onChange, isIntegratedChecklist = false, controls = [] }) => {
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const getActualFieldName = (displayName: string): string => {
    const fieldMap: { [key: string]: string } = { "PIMS": "pims", "ISMS": "isms", "BCMS": "bcms", "CMMI": "cmmi", "AIMS": "aims", "SOC 1": "soc1", "SOC 2": "soc2", "QMS": "qms", " ERM": "erm", "ITSM": "itsm", "ERS": "ers", "OHS": "ohs" };
    return fieldMap[displayName] || displayName.toLowerCase().replace(/\s+/g, '');
  };
  if (!question) return null;
  const handleValidationAndSave = () => {
    const questionText = question.questionText?.trim();
    const expectedArtifact = question.expectedArtifact?.trim();
    if (!questionText || !expectedArtifact) {
      setMessage(createToastMessage("Please fill all required fields", "warning", 3000));
      return;
    }
    onSave();
  };
  const renderIntegratedFields = () => {
    return controls.map((control: string) => {
      const actualFieldName = getActualFieldName(control);
      return (
        <label key={control}>
          {control}:
          <textarea name={actualFieldName} value={question[actualFieldName] || ""} onChange={onChange} />
        </label>
      );
    });
  };
  return (
    <div className="modal-overlay-checklist">
      <div className="modal-content-checklist">
        <h3>Edit Question</h3>
        <div className="modal-body-checklist">
          <label>Question:
            <textarea name="questionText" value={question.questionText || ""} onChange={onChange} required />
          </label>
          <label>Expected Artifact:
            <textarea name="expectedArtifact" value={question.expectedArtifact || ""} onChange={onChange} required />
          </label>
          {!isIntegratedChecklist && (
            <label> Control/Practice Area:
              <textarea name="practiceArea" value={question.practiceArea || ""} onChange={onChange} />
            </label>
          )}
          {isIntegratedChecklist && renderIntegratedFields()}
        </div>
        <div className="buttons">
          <button className="cancelbutton" onClick={onClose}>Cancel</button>
          <button className="savebutton" onClick={handleValidationAndSave}>Save</button>
        </div>
        {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
      </div>
    </div>
  );
};
export default AdminCheckListDetailsEdit;